import connector from "@/repository/connector";

export default {
  async list(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("payouts-methods/", { params }),
    );
  },
  async get(id) {
    return connector.requestWithFallback(
      () => connector.connector.get(`payouts-methods/${id}/`),
    );
  },
  async create(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("payouts-methods/", payload),
    );
  },
  async replace(id, payload) {
    return connector.requestWithFallback(
      () => connector.connector.put(`payouts-methods/${id}/`, payload),
    );
  },
  async update(id, payload) {
    return connector.requestWithFallback(
      () => connector.connector.patch(`payouts-methods/${id}/`, payload),
    );
  },
  async remove(id) {
    return connector.requestWithFallback(
      () => connector.connector.delete(`payouts-methods/${id}/`),
    );
  },
};
